import { registerArchetype } from './index.js';
import { applyDamage, computeDamage, livingEnemies, enemySide, getRuntimes, effectiveAtk, effectiveDef } from '../combat.js';
registerArchetype({
    id: 'frontline_hit',
    apply: ({ state, source, params, rng }) => {
        const mult = params.multiplier ?? 1.3;
        const front = livingEnemies(state, source.side).filter(e => e.slot <= 1);
        if (front.length === 0)
            return;
        const target = front.reduce((m, e) => e.runtime.hp < m.runtime.hp ? e : m);
        const sourceRt = getRuntimes(state, source.side)[source.slot];
        const dmg = computeDamage(effectiveAtk(sourceRt) * mult, effectiveDef(target.runtime));
        applyDamage(state, source, { side: enemySide(source.side), slot: target.slot }, dmg, false, rng);
    }
});
